import React, { useState } from "react";
import { Play } from "lucide-react";
import { Dialog, DialogContent } from "./ui/dialog";
import { videoSection } from "../mock";

const VideoSection = () => {
  const [open, setOpen] = useState(false);
  const v = videoSection;

  return (
    <section className="section brand-gradient-soft">
      <div className="mx-auto max-w-6xl px-4">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-[#2E9E6A] font-semibold uppercase tracking-wide text-sm">{v.eyebrow}</span>
          <h2 className="font-display font-bold text-3xl md:text-4xl text-[#0E2A33] mt-2">{v.title}</h2>
          <p className="text-slate-600 mt-4">{v.subtitle}</p>
        </div>

        <div
          className="mt-10 relative rounded-[2rem] overflow-hidden shadow-2xl cursor-pointer group max-w-4xl mx-auto"
          onClick={() => setOpen(true)}
        >
          <img src={v.poster} alt="Home care video" loading="lazy" decoding="async" className="w-full h-[300px] md:h-[460px] object-cover transition-transform duration-500 group-hover:scale-105" />
          <div className="absolute inset-0 bg-[#0A4557]/40 grid place-items-center">
            <div className="h-20 w-20 rounded-full bg-white/90 grid place-items-center shadow-xl transition-transform group-hover:scale-110">
              <Play className="h-9 w-9 text-[#2E9E6A] ml-1 fill-[#2E9E6A]" />
            </div>
          </div>
        </div>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-4xl p-0 overflow-hidden bg-black border-0">
          <div className="aspect-video w-full">
            {open && (
              <video
                data-testid="company-video-player"
                className="w-full h-full"
                src={v.videoUrl}
                controls
                autoPlay
                playsInline
              />
            )}
          </div>
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default VideoSection;
